
import {first} from 'rxjs/operators';
import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CaptchaService } from './captcha.service';
import { Subscription } from 'rxjs';
import { BaseControlValueAccessor } from '../../core/base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'jhi-captcha',
    templateUrl: './captcha.component.html',
    styleUrls: ['./captcha.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: CaptchaComponent,
        multi: true
    }]
})
export class CaptchaComponent extends BaseControlValueAccessor implements OnInit, OnDestroy {
    wasCaptchaReloaded = false

    captchaTexte = {
        texte: ''
    };

    audio: any;

    captchaUrl: any;
    imageCaptchaUrl: any;
    isAudioCaptcha = true;

    private subscription: Subscription;

    constructor(injector: Injector, private sanitizer: DomSanitizer, private captchaService: CaptchaService) {
        super(injector);
    }

    ngOnInit() {
        this.audio = new Audio();
        this.reload(true);
        this.subscription = this.captchaService.reloadEvents.subscribe(() => this.reload());
    }

    ngOnDestroy() {
        // destroy audio here
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
        this.subscription.unsubscribe();
        super.ngOnDestroy();
    }

    onAudioPlay() {
        this.audio.play();
    }

    reload(isOninit?: boolean) {
        this.getCaptcha(this.isAudioCaptcha);
        this.resetCaptcha();

        // this allows for captcha accesibility reload message to appear
        if (!isOninit) {
            this.wasCaptchaReloaded = true;
            setTimeout(() => { this.wasCaptchaReloaded = false; }, 1000)
        }
    }

    private getCaptcha(isAudioCaptcha: boolean) {
        this.isAudioCaptcha = isAudioCaptcha;
        this.captchaService.getCaptcha(isAudioCaptcha).pipe(first()).subscribe(
            blob => {
                this.audio.src = URL.createObjectURL(blob);
                this.imageCaptchaUrl = null;
                if (isAudioCaptcha) {
                    this.captchaService.getImageCaptcha().subscribe(imageBlob => {
                        this.imageCaptchaUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(imageBlob));
                    });
                }
            },
        );
    }

    modelValueChanged(value: any): void {
        this.captchaTexte.texte = value;
    }

    resetCaptcha() {
        this.captchaTexte.texte = '';
        if (this.onChange) {
            this.onChange(this.captchaTexte.texte);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/captcha/captcha.component.ts